<!-- SvgIcon.vue -->
<template>
    <svg :class="svgClass" aria-hidden="true">
        <use :xlink:href="iconName" />
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        iconClass: {
            type: String,
            required: true
        },
        className: {
            type: String,
            default: ''
        }
    },
    computed: {
        iconName() {
            return `#icon-${this.iconClass}` // 对应上面配置的 symbolId 规则
        },
        svgClass() {
            return `svg-icon ${this.className}`
        }
    }
}
</script>

<style scoped>
.svg-icon {
    width: 1em;
    height: 1em;
    fill: currentColor; /* 通过color属性控制图标颜色 */
}
</style>